import { render, staticRenderFns } from "./TemplateToolbar.vue?vue&type=template&id=4a510f53"
import script from "./TemplateToolbar.vue?vue&type=script&lang=js"
export * from "./TemplateToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports